import React from 'react'
import PropTypes from 'prop-types'
import NextLink from 'next/link'
import styled from 'styled-components'

const LinkContent = styled.div`
  cursor: pointer;
`

const Link = (props) => {
  const { replace, href, to, children } = props

  const handleClick = (ev) => {

    if (replace && href) {
      ev.preventDefault()
      window.location.replace(href)
    }
  }

  if (!to && !href) {
    return <div>{children}</div>
  }

  return to
    ? <NextLink href={to.replace('/edu', '')}><LinkContent>{children}</LinkContent></NextLink>
    : <a href={href} onClick={handleClick} {...props}><>{children}</></a>
}


Link.navigate = (props) => {
  let link = typeof props === 'string' ? props : props.to || props.href
  let replace = props.replace

  if (replace) {
    window.location.replace(link)
  } else {
    window.location.assign(link)
  }
}

Link.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  replace: PropTypes.bool,
  children: PropTypes.any
}

export default Link
